import * as yup from 'yup';

export const sellOrdersValidations = yup.object().shape({
  reason: yup
    .string()
    .required('A observação é obrigatória'),
  userPassword: yup
    .string()
    .required('A senha é obrigatória')
});